__turbopack_context__.v({
  "betaFeatureLabel": "Lc01WW_betaFeatureLabel",
  "betaItem": "Lc01WW_betaItem",
  "contentIsConstrained": "Lc01WW_contentIsConstrained",
  "description": "Lc01WW_description",
  "image": "Lc01WW_image",
  "imageIsConstrained": "Lc01WW_imageIsConstrained",
  "item": "Lc01WW_item",
  "itemWithBetaItems": "Lc01WW_itemWithBetaItems",
  "singleRow": "Lc01WW_singleRow",
  "size-112x112": "Lc01WW_size-112x112",
  "size-240x240": "Lc01WW_size-240x240",
  "size-48x48": "Lc01WW_size-48x48",
  "title": "Lc01WW_title",
  "twoColumns": "Lc01WW_twoColumns",
});
